import { createApp } from 'vue'
import App from './Index.vue'
import { initializePage } from '../../bootstrap/pageBootstrap.js'

import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';
import SlideUpDown from 'vue3-slide-up-down';
import { VueCookieNext } from 'vue-cookie-next';
import VueGoogleMaps from '@fawmi/vue-google-maps';

// Initialize page bootstrap
initializePage().then((result) => {
  if (!result.success) {
    console.warn('[YourDetails] Bootstrap failed:', result.error);
  }
});

let app = createApp(App);

app.use(PrimeVue);
app.component('Dialog', Dialog);
app.use(VueCookieNext);
VueCookieNext.config({ expire: '1m' });
app.component('slide-up-down', SlideUpDown);

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCxCb7iRkeG6pVT-_6tjVC2glQZK2UF59s',
        libraries: "places"
    },
});

app.mount('#app');
